import React from 'react';
import PropTypes from 'prop-types';
import {Checkbox, FormControlLabel} from '@mui/material';

const FacetItemCheckbox = React.memo(({onCheckItem, label, name, value, checked}) => {
    return (
        <FormControlLabel
            control={
                <Checkbox
                    name={name}
                    value={value}
                    checked={checked}
                    color="primary"
                    onChange={onCheckItem}
                />
            }
            label={label}
        />
    )
});

FacetItemCheckbox.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool
};

export default FacetItemCheckbox;